import styled from 'styled-components'
export const AboutSection = styled.div`
    height: 500px;
    background-image: url('images/home_page/about_flower_2.jpg');
    background-size: cover;
    background-position: center;
    background-attachment: fixed
`

export const AboutInfo = styled.div`
    padding-top: 100px;
    width: 50%;
    float: left;
   
`

export const InfoTitle = styled.h2`
    font-weight: bold;
    font-size: 50px;
    margin:5px 0
    color: #FFFFFF;
    font-family: 'Dancing Script', cursive;
`

export const Span = styled.span`
    font-weight: normal
`

export const InfoDir = styled.h4`
    font-size: 40px;
    color: #FFD700;
    margin-top:10px;
    margin-bottom: 20px
    font-family: 'Indie Flower', cursive;
`

export const InfoDesc = styled.p`
    color: #FFFFFF;
    margin-bottom: 15px;
    line-height: 1.8
    font-family: 'Indie Flower', cursive;
`

export const Anchor = styled.a`
    text-decoration: none
`